import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { IdInterface, ProductInterface } from '../data';
import { ProductProvider } from '../providers/product.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface AddProductsUseCaseParams {
    products: ProductInterface[];
    check: boolean;
    clientCode?: IdInterface;
}

@Injectable()
export class AddSelectedProductsUseCase implements UseCaseWithParam<AddProductsUseCaseParams, Observable<Transaction<void>>> {
    constructor(private contractProvider: ContractProvider, private productProvider: ProductProvider) {}

    bind(params: AddProductsUseCaseParams): Observable<Transaction<void>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) =>
                        this.productProvider.addSelected(contract.encryptedCode, params.products).pipe(
                            switchMap((transactionAdd) =>
                                transactionAdd.map(
                                    () =>
                                        this.productProvider.findSelected(contract.encryptedCode, params.clientCode).pipe(
                                            switchMap((transactionSelected) =>
                                                transactionSelected.map(
                                                    (selectedProducts) => {
                                                        if (params.check) {
                                                            return this.productProvider
                                                                .checkSelected(contract.encryptedCode, selectedProducts)
                                                                .pipe(
                                                                    map((transactionCheck) =>
                                                                        transactionCheck.map(
                                                                            () => Transaction.success<void>(),
                                                                            (throwable) => Transaction.error(throwable.message)
                                                                        )
                                                                    )
                                                                );
                                                        }

                                                        return of(Transaction.success<void>());
                                                    },
                                                    (throwable) => of(Transaction.error(throwable.message))
                                                )
                                            )
                                        ),
                                    (throwable) => of(Transaction.error(throwable.message))
                                )
                            )
                        ),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
